import { Injectable, inject } from "@angular/core";
import moment from "moment";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { IDagKvantitet } from "../models/dagkvantitet";
import { DateUtils } from "../utils/date-utils";
import { ApiClientService } from "./api-client.service";

@Injectable({
    providedIn: "root"
})
export class FordelaService {
    private readonly apiClient = inject(ApiClientService);

    getFordeladKvantitet(totalKvantitet: number, periodStart: Date, periodEnd: Date): Observable<IDagKvantitet[]> {
        return this.apiClient
            .get<IDagKvantitet[]>("kundorderrad/fordela", false, {
                periodStart: moment(periodStart).format(DateUtils.dateformat),
                periodEnd: moment(periodEnd).format(DateUtils.dateformat),
                totalKvantitet: totalKvantitet
            })
            .pipe(
                tap(result => { result.forEach(x => x.datum = new Date(x.datum)); })
            );
    }
}
